module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eGHTs"))).then(() => parcelRequire('dJXJK'));